import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/lib/api";
import { DEFAULT_FEATURES } from "@/lib/tiers";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [config, setConfig] = useState(null);

  const loadConfig = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setConfig(data);
      return data;
    } catch (e) {
      console.error("Config load failed:", e);
      return null;
    }
  }, []);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      loadConfig();
    } catch (e) {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, [loadConfig]);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const login = (userData, token) => {
    if (token) localStorage.setItem("cc_token", token);
    setUser(userData);
    loadConfig();
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.error("Logout request failed:", e); }
    localStorage.removeItem("cc_token");
    setUser(false);
    setConfig(null);
    window.location.href = "/login";
  };

  const features = config?.features || DEFAULT_FEATURES;

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, logout, checkAuth, config, features, loadConfig }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
